import React from 'react';
import { WifiOff, Wifi, RefreshCw } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

export const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();
  const [showDetails, setShowDetails] = React.useState(false);

  if (isOnline) return null;

  return (
    <div className="fixed top-[calc(1rem+env(safe-area-inset-top))] left-1/2 -translate-x-1/2 z-50 animate-fade-in max-w-[calc(100%-2rem)]">
      <div 
        className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-4 py-3 rounded-xl shadow-elegant flex items-center gap-3 cursor-pointer hover-lift"
        onClick={() => setShowDetails(!showDetails)}
      >
        <div className="bg-white/20 p-1.5 rounded-lg">
          <WifiOff className="w-4 h-4" />
        </div>
        <div>
          <p className="text-sm font-semibold">Modo Offline</p>
          {showDetails && (
            <p className="text-xs opacity-90 mt-1">
              Menú guardado localmente • Sin conexión necesaria
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export const OnlineIndicator: React.FC = () => {
  const { isOnline } = usePWA();
  const [wasOffline, setWasOffline] = React.useState(false);
  const [showIndicator, setShowIndicator] = React.useState(false);
  const [isSyncing, setIsSyncing] = React.useState(false);

  React.useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
    } else if (wasOffline) {
      setShowIndicator(true);
      setIsSyncing(true);
      
      // Simular sincronización
      setTimeout(() => {
        setIsSyncing(false);
      }, 1500);

      const timer = setTimeout(() => {
        setShowIndicator(false);
        setWasOffline(false);
      }, 4000);
      
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  if (!showIndicator) return null;

  return (
    <div className="fixed top-[calc(1rem+env(safe-area-inset-top))] left-1/2 -translate-x-1/2 z-50 animate-slide-up max-w-[calc(100%-2rem)]">
      <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-3 rounded-xl shadow-elegant flex items-center gap-3">
        <div className="bg-white/20 p-1.5 rounded-lg">
          {isSyncing ? (
            <RefreshCw className="w-4 h-4 animate-spin" />
          ) : (
            <Wifi className="w-4 h-4" />
          )}
        </div>
        <div>
          <p className="text-sm font-semibold">
            {isSyncing ? 'Sincronizando...' : '¡Conexión restaurada!'}
          </p>
          {!isSyncing && (
            <p className="text-xs opacity-90">Datos actualizados</p>
          )}
        </div>
      </div>
    </div>
  );
};
